import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import axios from '../../store/axios-secure'
import { FaTimes, FaCircle } from 'react-icons/fa'

export default function BroadcastContainer({
    selectedBrodcastFilter,
    setSelectedBroadcastFilter,
    currentChat,
    setShowBroadCastPage,
    handleBroadcastMessage,
    socket,
    // setShowChatContainer,
    // setCurrentSelected,
}) {
    const [broadMessage, setBroadMessage] = useState('')

    const filterOptions = [
        'my active clients',
        'active clients except',
        'only share with',
    ]

    const onSendBroadcastClick = async (msg) => {
        if (msg.trim() === '') {
            return
        }
        setBroadMessage('')
        await handleBroadcastMessage(msg)
    }

    const handleFilterClick = (filterText) => {
        setSelectedBroadcastFilter(filterText)
    }

    return (
        <Container>
            <div className="chat-header">
                <div className="user-details">
                    <div className="username">Broadcast a message</div>
                </div>
                <FaTimes
                    onClick={() => {
                        setShowBroadCastPage(false)
                        setSelectedBroadcastFilter('my active clients')
                    }}
                    className="close-icon"
                />
            </div>
            <div className="text-area-container">
                <textarea
                    className="text-area"
                    placeholder="write your message here to broadcast..."
                    value={broadMessage}
                    onChange={(e) => {
                        setBroadMessage(e.target.value)
                    }}
                />
            </div>
            <div className="options-container">
                {filterOptions.map((text, index) => (
                    <div
                        key={index}
                        className="option"
                        onClick={() => handleFilterClick(text)}
                    >
                        <FaCircle
                            className="circle-icon"
                            style={{
                                color:
                                    selectedBrodcastFilter === text
                                        ? '#36f5c7'
                                        : null,
                            }}
                        />
                        <span>{text}</span>
                    </div>
                ))}
            </div>
            <div className="broadcast-button-container">
                <span
                    className="broadcast-button"
                    style={{
                        color:
                            broadMessage.trim().length < 1 ? null : '#101317 ',
                        backgroundColor:
                            broadMessage.trim().length < 1
                                ? '#101317'
                                : '#36f5c7 ',
                        // : '#1f2731',
                    }}
                    onClick={() => {
                        onSendBroadcastClick(broadMessage)
                    }}
                >
                    Send
                </span>
            </div>
        </Container>
    )
}

const Container = styled.div`
    @media (max-width: 720px) {
        .chat-container {
            width: 100vw;
            height: 100vh;
        }
    }
    position: fixed;
    height: 80vh;
    background-color: #101317;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid #857c7c69;
    width: 30vw;
    display: grid;
    gap: 0.1rem;
    bottom: 0;
    right: 256px;
    overflow: hidden;
    z-index: 10000;

    .chat-header {
        position: absolute;
        top: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 17px 10px;
        background-color: #10130f;

        .user-details {
            display: flex;
            align-items: center;
            gap: 1rem;

            .username {
                color: white;
                font-size: 1.2rem;
            }
        }

        .close-icon {
            font-size: 18px;
            color: white;
            cursor: pointer;
        }
    }

    .text-area-container {
        display: flex;
        justify-content: center;
        margin-top: 26%;

        .text-area {
            // margin-top: 26%;
            background-color: #1f2731;
            color: white;
            border: 1px solid #857c7c69;
            width: 90%;
            height: 80px;
            max-height: 80px;
            resize: none;
            padding: 10px;
            border-radius: 5px;
        }
    }

    .options-container {
        display: flex;
        flex-direction: column;
        text-align: center;
        margin-top: 10px;

        .option {
            display: flex;
            height: 30px;
            gap: 5%;
            align-items: center;
            margin-left: 25%;
            cursor: pointer;

            .circle-icon {
                color: #1f2731;
                align-items: center;
            }

            span {
                align-items: center;
                color: white;
            }
        }
    }

    .broadcast-button-container {
        text-align: center;
        margin-top: 20px;

        .broadcast-button {
            text-align: center;
            border: 1px solid #2c2c2c;
            border-radius: 4px;
            padding: 6px;
            cursor: pointer;
            color: white;
            background-color: #1f2731;
        }
    }
`
